import * as React from 'react';
import Button from '@mui/material/Button';
import CustomizeMenu from './CustomizeMenu';
import { IconButton, PopoverOrigin } from '@mui/material';
import { ActionMenuItem } from '../../models/interfaces';

interface IProps {
  idButton: string;
  idMenu: string;
  menuItems: ActionMenuItem[];
  textButton?: string | null;
  iconButton?: React.ReactNode | null;
  endIcon?: React.ReactNode | null;
  className?: string | null;
  onlyIcon?: boolean | null;
  anchorOrigin?: PopoverOrigin | null;
  transformOrigin?: PopoverOrigin | null;
  onClick?: () => void;
  isCloseMenu?: boolean;
}

export default function SelectMenu(props: IProps) {
  const {
    idButton,
    idMenu,
    menuItems,
    textButton,
    iconButton,
    className,
    onlyIcon,
    anchorOrigin,
    transformOrigin,
    endIcon,
    onClick,
    isCloseMenu,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  React.useEffect(() => {
    if (isCloseMenu) setAnchorEl(null);
  }, [isCloseMenu]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    onClick && onClick();
  };

  return (
    <div>
      {onlyIcon ? (
        <IconButton
          id="more-action"
          aria-controls={open ? idMenu : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          {iconButton}
        </IconButton>
      ) : (
        <Button
          id={idButton}
          aria-controls={open ? idMenu : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="contained"
          disableElevation
          onClick={handleClick}
          startIcon={iconButton}
          endIcon={endIcon}
          className={className || ''}
        >
          {textButton}
        </Button>
      )}

      <CustomizeMenu
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        idButton={idButton}
        idMenu={idMenu}
        menuItems={menuItems}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      />
    </div>
  );
}
